import { capture } from ".";

/** Fires when the user interacts with the first field of a form. */
export function trackFormStart(formName: string): void {
  capture("form_start", { form_name: formName, page_path: window.location.pathname });
}

/**
 * Fires when a single step of a multi-step form is completed.
 *
 * `value` carries the selected answer and must only ever be passed for
 * single-select steps, whose options are a fixed, non-identifying list. Values
 * typed by the visitor (company URLs, free text) are lead data and stay out of
 * the analytics vendor — the step still counts, just without its content.
 */
export function trackFormStep(
  formName: string,
  step: { step_key: string; step_index: number; value?: string },
): void {
  capture("form_step_completed", { form_name: formName, ...step });
}

/**
 * Fires when the full form is submitted. `choiceAnswers` must contain only
 * answers to single-select steps — see `trackFormStep`.
 */
export function trackFormSubmit(formName: string, choiceAnswers: Record<string, string>): void {
  capture("form_submitted", { form_name: formName, ...choiceAnswers });
}
